import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import { assignedLocation, WarehouseLocationAssignmentViewModel } from "./warehouseLocationAssignment-viewModel"

export class WarehouseLocationAssignmentView extends View<WarehouseLocationAssignmentViewModel>{
    GetViewUniqueId(): string {
        return "V-D61230ED-A0A7-4328-9AAE-596EAF27B084"
    }
    loadHtml(): string {
        let element = require('./warehouseLocationAssignment.html').default;
        let style = require('./warehouseLocationAssignment.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set assignedLocations(v: ObservableArray<assignedLocation>) { this._assignedLocation = v; } public get assignedLocations(): ObservableArray<assignedLocation> { return this._assignedLocation;} private _assignedLocation: ObservableArray<assignedLocation>;
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

}
